module.exports = __webpack_public_path__ + "assets/scoober_tag-ddeec1.svg";